import { useQuery } from 'react-query'
import {
  fetchAcademicYears,
  fetchMentorMasterCourses
} from '../API'

export default (orgId, token, selectedAcademicYearId) => {
  const { isLoading: isLoadingAcademicYears, data: academicYears } = useQuery(
    ['academic-years'],
    () => fetchAcademicYears(orgId, token),
    {
      refetchOnWindowFocus: false
    }
  )

  const { isLoading: isLoadingMentorMasterCourses, data: mentorMasterCourses } = useQuery(
    ['mentor-master-courses-' + selectedAcademicYearId],
    () => fetchMentorMasterCourses(orgId, token, selectedAcademicYearId),
    {
      refetchOnWindowFocus: false,
      enabled: !!selectedAcademicYearId
    }
  )

  const isDataLoading = isLoadingAcademicYears || isLoadingMentorMasterCourses

  return {
    isDataLoading,
    academicYears,
    mentorMasterCourses
  }
}



// WEBPACK FOOTER //
// ./src/components/mycourses/hooks/useFetchData.js